export const settingsImages = {
  circle_check_icon: 'assets/img/bed-bath/circle-check.svg',
  upload_icon: 'assets/img/help/upload.svg',
  rocket_icon: 'assets/img/help/rocket.svg',
  arrow_switch_icon: 'assets/new-img/arrows_switch.svg',
  u_enter_icon: 'assets/new-img/u_enter.svg',
  profile_changer_icon: 'assets/new-img/icons/profile-changer.svg',
  staff_holiday_icon: 'assets/img/menuIcon/staff_holiday.svg',
  photo_icon: 'assets/img/photo.svg',
  link_two_icon: 'assets/img/link-two.svg',
  team_icon: 'assets/img/menuIcon/team.svg',
  staff_lock_icon: 'assets/img/menuIcon/staff_lock.svg',
  notification_icon: 'assets/img/76-notification.svg',
  office_approval_icon: 'assets/img/menuIcon/office_approvel.svg',
  f_icon: 'assets/img/f.svg',
  upload_icon_v2: 'assets/img/upload.svg',
  undo_solid_icon: 'assets/img/menuIcon/undo_solid.svg',
  eye_close_icon: 'assets/new-img/site-logo/eye-closed.svg',
  group_icon_v2: 'assets/img/Group37072.svg',
  color_picker_icon: 'assets/img/bed-bath/color-picker.svg',
  save_logo: 'assets/img/bed-bath/save-logo.svg',
  big_placeholder_icon: 'assets/img/big-placeholder.png',
  office_branding_icon: 'assets/img/menuIcon/office_branding.svg',
  import_export_icon: 'assets/img/menuIcon/import_export.svg',
  kanban_board_icon: 'assets/img/menuIcon/kanban_board.svg',
  mail_template_icon: 'assets/img/menuIcon/mail_template.svg',
  email_account_icon: 'assets/img/menuIcon/email_account.svg',
  domain_icon: 'assets/img/menuIcon/domain.svg',
  rotation_icon: 'assets/img/menuIcon/rotation.svg',
  category_icon: 'assets/img/category.svg',
  box_icon: 'assets/img/box.svg',
  setting_1_icon: 'assets/menu-customisation-icons/Settings/settings1.svg',
  setting_2_icon: 'assets/menu-customisation-icons/Settings/settings2.svg',
  setting_3_icon: 'assets/menu-customisation-icons/Settings/settings3.svg',
  setting_4_icon: 'assets/menu-customisation-icons/Settings/settings4.svg',
  setting_5_icon: 'assets/menu-customisation-icons/Settings/settings5.svg',
};
